//@flow
import React, { useState } from 'react';
import classNames from 'classnames';
import './style.scss';

type Props = {
  onClick: void,
  buttonName: string,
  containerClassName: ?string,
};

export const GoToBrowser = (props: Props) => {
  const { buttonName, onClick, containerClassName } = props;

  const containerClassNames = classNames('go-to-browser', containerClassName);

  return (
    <button className={containerClassNames} onClick={onClick}>
      <div className={'btn-name'}>
        <div className={'navigate-icon'} />
        {buttonName}
      </div>
    </button>
  );
};
